export default "__VITE_ASSET__CYdz0r5J__"